import React from "react";
// @ts-ignore
import { Button, LoadingIndicator } from "@lululemon/ui-library";
import cn from "classnames";
import PaginationCount from "./PaginationCount";
import styles from "./pagination.module.scss";

interface PaginationProps {
  totalCount: number;
  visibleCount: number;
  onClick: () => void;
  isLoading: boolean;
  className?: string;
}

/**
 * PaginationButton component
 * @param {number} totalCount - The total number of products
 * @param {number} visibleCount - The number of products currently visible
 * @param {() => void} onClick - The function to call when the button is clicked
 * @param {boolean} isLoading - Whether the component is in a loading state
 * @param {string} className - Additional classes to add to the component
 * @returns {React.ReactElement}

 */
const PaginationButton: React.FC<PaginationProps> = React.memo(
  ({ totalCount, visibleCount, onClick, isLoading, className }) => {
    return (
      <div className={cn("OneLinkTx", styles.pagination, className)}>
        {isLoading ? (
          <LoadingIndicator color="gray" />
        ) : (
          <>
            <PaginationCount
              currentlyVisible={visibleCount}
              totalProductCount={totalCount}
            />

            {visibleCount < totalCount && (
              <Button
                variant="outline"
                onClick={onClick}
                className={styles.button}
              >
                View More Products
              </Button>
            )}
          </>
        )}
      </div>
    );
  }
);

export default PaginationButton;

PaginationButton.displayName = "PaginationButton";
